module.exports = __webpack_public_path__ + "assets/img/img29.9fddce12.png";